import { Mapper } from "../../../../base/utils/mapper";
import { TypeFilterGlassesModel } from "../../../../domain/models/consult/type-filter-glasses.model";
import { TypeFilterGlassesEntity } from "../entities/type-filter-glasses.entity";


export class TypeFilterGlassesImplementationRepositoryMapper extends Mapper<TypeFilterGlassesEntity, TypeFilterGlassesModel> {
    mapFrom(param: TypeFilterGlassesEntity): TypeFilterGlassesModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeFilterGlassesModel): TypeFilterGlassesEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}